var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYaongconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6H4.5C3.67157 6 3 6.67157 3 7.5V9.5C3 10.3284 3.67157 11 4.5 11H7.5H16.5H19.5C20.3284 11 21 10.3284 21 9.5V7.5C21 6.67157 20.3284 6 19.5 6Z",
    fill: "#D03660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C12 3.11929 13.1193 2 14.5 2H15C16.1046 2 17 2.89543 17 4V4C17 5.10457 16.1046 6 15 6H12V4.5Z",
    stroke: "#D03660",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C12 3.11929 10.8807 2 9.5 2H9C7.89543 2 7 2.89543 7 4V4C7 5.10457 7.89543 6 9 6H12V4.5Z",
    stroke: "#D03660",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.5V18C4 20.2091 5.79086 22 8 22H11.2L11.2 12.5H4ZM12.7 12.5L12.7 22H16C18.2091 22 20 20.2091 20 18V12.5H12.7Z",
    fill: "#D03660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaongconSelected);
export default __webpack_public_path__ + "static/media/yaongcon_selected.48165c7396a01e8e8b26f251f59d0413.svg";
export { ForwardRef as ReactComponent };